import VueScrollTo from 'vue-scrollto';
import Vue from 'vue';


Vue.use(VueScrollTo, {
  offset: -80,
  duration: 1000,
  cancelable: false,
});
